import { useTranslation } from '@eti/providers';
import { MOBILE_TRAVEL_PLAN } from '../../products';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import SmallCardLayout from '../../common/components/small-card-layout/SmallCardLayout';
import { jsx as _jsx } from "react/jsx-runtime";
export const texts = {
  persuasionContent: 'mobileTravelPlanPersuasionContent',
  upSell: 'mobileTravelPlanUpSellText',
  additionalInformation: 'mobileTravelPlanAdditionalInformation',
  readMoreContent: 'mobileTravelPlanReadMoreModalContent',
  text: 'mobileTravelPlanAbstractSmallCard',
  title: 'mobileTravelPlanTitle'
};
const SmallMobileTravelPlan = _ref => {
  let {
    form,
    isSelected,
    order,
    layoutType
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    text,
    readMoreContent,
    title,
    persuasionContent
  } = getTranslatedTexts(texts, t);
  return /*#__PURE__*/_jsx(SmallCardLayout, {
    description: text,
    form: form,
    isSelected: isSelected,
    layoutType: layoutType,
    order: order,
    persuasion: persuasionContent,
    productId: MOBILE_TRAVEL_PLAN.id,
    productName: MOBILE_TRAVEL_PLAN.name,
    readMoreContent: readMoreContent,
    title: title
  });
};
export default SmallMobileTravelPlan;
//# sourceMappingURL=SmallMobileTravelPlan.js.map